import { Dialog } from '@/components/UI'
import { useTranslation } from 'react-i18next'

type Props = {
  /** ダイアログの表示状態 */
  opened: boolean
  /** OK ボタン押下時 */
  onClose: () => void
}

export const DialogCouponUsed = ({ opened, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={opened} closeFunc={onClose} showCloseButton={false}>
      <div data-testid="dialog-coupon-used" className="px-4 pb-4">
        {/* タイトル */}
        <div className="flex h-[44px] items-center justify-center">
          <h2 className="text-[16px] font-bold leading-[24px] text-black">
            {t('coupon.used_title', 'クーポンを使用しました')}
          </h2>
        </div>

        {/* OK ボタン */}
        <div className="mt-4 flex justify-center">
          <button
            type="button"
            className="flex h-[48px] w-[123px] items-center justify-center rounded-full bg-[#EEEEEE] text-[15px] font-bold leading-[24px] text-[#757575]"
            onClick={onClose}
          >
            {t('common.ok', 'OK')}
          </button>
        </div>
      </div>
    </Dialog>
  )
}
